"use client";

export default function GlobalError({reset}: {error: Error; reset: () => void}) {
  return (
    <html lang="en">
      <body>
        <main
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: 24,
            background: "#FBF7EF",
            color: "#173A2B",
            fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif"
          }}
        >
          <section
            style={{
              width: "min(100%, 520px)",
              border: "1px solid rgba(26, 60, 46, 0.16)",
              borderRadius: 18,
              background: "#fffaf1",
              padding: 28,
              boxShadow: "0 24px 70px rgba(26, 60, 46, 0.14)"
            }}
          >
            <p style={{margin: "0 0 10px", fontSize: 13, fontWeight: 800, letterSpacing: 1.2, color: "#A97820"}}>
              STAYYOO
            </p>
            <h1 style={{margin: 0, fontSize: 32, lineHeight: 1.1}}>StayYoo could not finish loading.</h1>
            <p style={{margin: "14px 0 24px", color: "#5F6F66", lineHeight: 1.7}}>
              Please refresh the page. If you just rebuilt the app locally, restart the dev server and open the home page again.
            </p>
            <div style={{display: "flex", flexWrap: "wrap", gap: 12}}>
              <button
                onClick={reset}
                style={{
                  border: 0,
                  borderRadius: 999,
                  background: "#173A2B",
                  color: "white",
                  cursor: "pointer",
                  fontWeight: 800,
                  padding: "12px 18px"
                }}
              >
                Try again
              </button>
              <button
                onClick={() => {
                  window.location.href = "/";
                }}
                style={{
                  border: "1px solid rgba(26, 60, 46, 0.18)",
                  borderRadius: 999,
                  background: "transparent",
                  color: "#173A2B",
                  cursor: "pointer",
                  fontWeight: 800,
                  padding: "12px 18px"
                }}
              >
                Go home
              </button>
            </div>
          </section>
        </main>
      </body>
    </html>
  );
}
